// extracted by mini-css-extract-plugin
export default {"livegame":"LivePanel_livegame__Aa9Mk","show":"LivePanel_show__rH46c","team0":"LivePanel_team0__xdUyk","team1":"LivePanel_team1__VQBsR"};